import React from 'react';
import { useFormikContext } from 'formik';
import {
  AnyAssetApplication,
  FormikNewFormValues,
  useAssetTranslation,
} from '@mss/mss-component-library';
import { get } from 'lodash';
import {
  CopyArgs,
  copyToOtherAssets,
} from '../../../asset/util/copyToOtherAssets';
import { fieldNameToFormName } from '../Shared/inputUtil';

const CopyButton = (
  props: Omit<CopyArgs<AnyAssetApplication>, 'values' | 'setFieldValue'>
) => {
  const { t } = useAssetTranslation();
  const { fieldName, index } = props;
  const { values, setFieldValue } =
    useFormikContext<FormikNewFormValues<any>>();
  if (values.assets.length < 2) return null;
  const value = get(
    values,
    fieldNameToFormName(
      `${props.isCustomField ? 'custom_field_values.' : ''}${fieldName}`,
      index
    ),
    null
  );
  const hasValue = value !== '' && value != null;

  return (
    <span
      className={`text-xs font-normal mt-1 ${
        hasValue ? 'text-primary hover:underline cursor-pointer' : 'opacity-50'
      }`}
      onClick={
        hasValue
          ? copyToOtherAssets({
              values,
              setFieldValue,
              ...props,
            })
          : undefined
      }
    >
      {props.subType
        ? t('Copy to other assets of same subtype')
        : t('Copy to other assets')}
    </span>
  );
};

export default CopyButton;
